import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx/xlsx.mjs";
import Header from "../../../components/Header";

const Uploads = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const api_url = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const handleFileChange = (e) => {
    let uploadFile = e.target.files[0];
    if (uploadFile.name.split(".")[1].toLowerCase() === "xlsx") {
      setFile(uploadFile);

      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData.shift();
        const result = jsonData.map((row) => {
          const obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });

        setEmployees(result);
      };
      reader.readAsArrayBuffer(uploadFile);
    } else {
      toast.error("Invalid file format", {
        hideProgressBar: true,
        theme: "colored",
      });
      setFile(null);
    }
  };

  const submitUploads = () => {
    if (file) {
      setIsLoading(true);
      try {
        fetch(api_url + "users/upload-users", {
          method: "PATCH",
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(employees),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              let message = data.message;
              toast.success(message, {
                hideProgressBar: true,
                theme: "colored",
              });
              setTimeout(() => {
                navigate("/dashboard/admin");
              }, 2000);
              setIsLoading(false);
            } else {
              let message = data.message;
              toast.error(message, {
                hideProgressBar: true,
                theme: "colored",
              });
            }
          })
          .catch((error) => {
            toast.error(error.message, {
              hideProgressBar: true,
              theme: "colored",
            });
          });
      } catch (error) {
        toast.error(error.message, {
          hideProgressBar: true,
          theme: "colored",
        });
      }
    } else {
      toast.error("No file uploaded", {
        hideProgressBar: true,
        theme: "colored",
      });
    }
  };

  return (
    <>
      <ToastContainer transition={Slide} />
      <div className="uploads">
        <Header />
        <div className="text-lg text-center font-semibold flex items-center gap-2 my-8 px-5">
          <svg
            onClick={() => navigate(-1)}
            className="w-6 h-6 cursor-pointer"
            viewBox="0 0 27 16"
            fill="#272727"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M26 9C26.5523 9 27 8.55228 27 8C27 7.44772 26.5523 7 26 7V9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM26 7L1 7V9L26 9V7Z" />
          </svg>
          Upload Employee File
        </div>
        {/* products upload form */}
        <div className="px-5">
          {file && file.name.split(".")[1].toLowerCase() === "xlsx" ? (
            <div className="uploadedFile flex justify-center items-center gap-5 bg-slate-200 p-2 px-3 rounded-md mb-5">
              <h4 className="truncate">{file.name}</h4>
              <button
                className="bg-brand text-white p-2 rounded"
                onClick={() => setFile(null)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          ) : null}
          <div className="form mt-5">
            <div className="file-input flex items-center justify-center w-full">
              <label
                htmlFor="upload"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    aria-hidden="true"
                    className="w-10 h-10 mb-3 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                    ></path>
                  </svg>
                  <p className="mb-2 text-md text-gray-500">
                    <span className="font-semibold">Click to upload</span>
                  </p>
                  <p className="text-sm text-gray-500">
                    please upload only .xlsx file
                  </p>
                </div>
                <input
                  name="upload"
                  id="upload"
                  type="file"
                  className="hidden"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={(e) => handleFileChange(e)}
                />
              </label>
            </div>
            <div className="submit-button text-center mt-5">
              {isLoading ? (
                <button className="bg-green-500 text-sm text-white text-center rounded flex items-center gap-2 mx-auto p-2">
                  <svg
                    aria-hidden="true"
                    className="inline w-4 h-4 text-white animate-spin fill-black"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  uploading.......
                </button>
              ) : (
                <button
                  className="bg-green-500 text-sm text-white text-center rounded capitalize p-2"
                  onClick={() => submitUploads()}
                >
                  upload
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Uploads;
